// extracted by mini-css-extract-plugin
export default {"RubriqueNavigation":"RubriqueNavigationAdmin_RubriqueNavigation__5fzQk","active":"RubriqueNavigationAdmin_active__NacDE"};